import { render, staticRenderFns } from "./Previous.vue?vue&type=template&id=c753ceca"
import script from "./Previous.vue?vue&type=script&lang=js"
export * from "./Previous.vue?vue&type=script&lang=js"
import style0 from "./Previous.vue?vue&type=style&index=0&id=c753ceca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports